<template>
  <div>
    <van-contact-card type="add" add-text="添加就诊人" @click="onAdd" v-if="showAuthBtn" />
    <div
      role="button"
      tabindex="0"
      class="
        van-cell van-cell--clickable van-cell--center van-cell--borderless
        van-contact-card van-contact-card--edit" @click="editUser()" v-if="!showAuthBtn" 
    >
      <i class="van-icon van-icon-contact van-cell__left-icon"></i>
      <div
        class="van-cell__value van-cell__value--alone van-contact-card__value"
      >
        <div>姓名：{{userInfo.name}}</div>
        <div>证件号：{{userInfo.idenno}}</div>
      </div>
      <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
    </div>
  </div>
</template>
  <script>
import { CellGroup } from "vant";
import { ref } from "vue";
import requests from "../../api/requests.js";

export default {
  components: {},
  data() {
    return {
      userInfo: {},
      showAuthBtn:false,
    };
  },

  created() {
    let that = this;
    let globalOpenid = localStorage.getItem(this.GLOBAL.hosUrl);
    //第一次进来
    if (globalOpenid === "" || globalOpenid == null) {
      let code = this.$route.query.code;
      let httpURL = "/wx/wxauth?code=" + code;
      requests.get(httpURL).then(function (res) {
        if (res.data != null && res.data.openid != null) {
          that.userInfo.openid = res.data.openid;
          localStorage.setItem(that.GLOBAL.hosUrl, res.data.openid);
          that.getUserInfoByOpenId(that.userInfo.openid);
        } else {
          console.log(res);
        }
      });
    } else {
      that.userInfo.openid = globalOpenid;
      console.log("globalVal.openid:" + globalOpenid);
      that.getUserInfoByOpenId(that.userInfo.openid);
    }
  },
  methods: {
    //从建档数据里取的
    getUserInfoByOpenId(id) {
      const that = this;
      let httpURL = "/His/QueryRecord?openid=" + id;
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          that.userInfo = res.data;
        } else {
            that.showAuthBtn = true;
        }
      });
    },
    onAdd(){
        this.$router.push('/payFlow');
    },
    editUser(){
        this.$router.push('/payFlow');
    }
  },
};
</script>
  


// WEBPACK FOOTER //
// src/views/cardManage/index.vue